module.exports = __webpack_public_path__ + "static/women-559c3cccd3a6fa3693ffd04fa46a47fc.png";